import axios from 'axios';
import store from '../redux/store/store';

// API URL'yi doğrudan alıyoruz
const API_URL = import.meta.env.VITE_API_URL;

const authService = {
  signUp: (userData) => {
    const { acceptedTerms, ...payload } = userData;
    return axios.post(`${API_URL}/Auth/RegisterUser`, payload);
  },

  signIn: (userData) => {
    // Tam URL'yi kullanıyoruz, undefined eklenmesini önlüyoruz
    return axios.post(`${API_URL}/Auth/LoginUser`, userData);
  },

  quickLogin: (storeName) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.post(`${API_URL}/Auth/QuikLogin?storeName=${storeName}`, {}, {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
  },
};

export default authService;
